// extracted by mini-css-extract-plugin
module.exports = {"navButtons":"NavTabs_navButtons__36ggv"};